var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ActivityIndicator } from 'react-native';
import { Focusable } from '../../Focusable';
import { Icon } from '../../Icon';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet, useThemeContext } from '../../../hooks';
export const Base = (_a) => {
    var { value, style, isLoading, disabled, onPress, iconColor, iconHoverColor, active, hoverStyle } = _a, props = __rest(_a, ["value", "style", "isLoading", "disabled", "onPress", "iconColor", "iconHoverColor", "active", "hoverStyle"]);
    const styles = useStyleSheet(getStyles);
    const { size } = useThemeContext();
    const iconSize = {
        xxs: size.H,
        xs: size.I,
        sm: size.J,
        md: size.J,
        lg: size.J
    };
    return (React.createElement(Focusable, Object.assign({ style: [styles.container, styles[`container__${props.size}`], style], onPress: isLoading ? void 0 : onPress, disabled: disabled, hoverStyle: isLoading ? {} : hoverStyle }, (props.onMouseEnter ? { onMouseEnter: props.onMouseEnter } : {}), (props.onMouseLeave ? { onMouseEnter: props.onMouseLeave } : {})), ({ hovered }) => (React.createElement(React.Fragment, null, isLoading ? (React.createElement(ActivityIndicator, { color: iconColor, style: styles[`loader__${props.size}`] })) : (React.createElement(Icon, { name: value, size: iconSize[props.size], color: hovered ? iconHoverColor : iconColor, filled: active }))))));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: { borderRadius: 9999 },
    container__xxs: {
        padding: size.B
    },
    container__xs: {
        padding: size.C
    },
    container__sm: {
        padding: size.C
    },
    container__md: {
        padding: size.D
    },
    container__lg: {
        padding: size.F
    },
    loader__xxs: {
        width: size.H,
        height: size.H
    },
    loader__xs: {
        width: size.I,
        height: size.I
    },
    loader__sm: {
        width: size.J,
        height: size.J
    },
    loader__md: {
        width: size.J,
        height: size.J
    },
    loader__lg: {
        width: size.J,
        height: size.J
    }
}));
//# sourceMappingURL=Base.js.map